import { useEffect } from "react";
import { connect } from "react-redux";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { actions } from "redux-router5";
import type { Dispatch } from "@reduxjs/toolkit";
import type { RootState } from "./store";
import type { CurrentUser } from "./generated-axios-client";
import { routeNames } from "./common/routes";
import ConnectedAppLayout from "./AppLayout";

type Props = {
  dispatch: Dispatch;
  user: CurrentUser | undefined;
};

export function UserPage({ dispatch, user }: Props) {
  useEffect(() => {
    if (user) {
      dispatch(actions.navigateTo(routeNames.USER_PROFILE_VIEW, { id: user.id }));
    }
  }, [user, dispatch]);

  return (
    <ConnectedAppLayout>
      <Spin indicator={<LoadingOutlined spin />} size="large" />
    </ConnectedAppLayout>
  );
}

export const ConnectedUserPage = connect((state: RootState) => ({
  user: state.userstate.user,
}))(UserPage);

export default ConnectedUserPage;
